import { Button, NumericInput, Switch } from "@blueprintjs/core";

export type LayoutCanvasToolbarProps = {
  disabled?: boolean;
  snapEnabled: boolean;
  gridSize: number;
  canAdd?: boolean;
  onToggleSnap: () => void;
  onGridSizeChange: (gridSize: number) => void;
  onAddTile: () => void;
};

export function LayoutCanvasToolbar({
  disabled,
  snapEnabled,
  gridSize,
  canAdd = true,
  onToggleSnap,
  onGridSizeChange,
  onAddTile,
}: LayoutCanvasToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-4 mb-2">
      <Button
        disabled={disabled || !canAdd}
        icon="add"
        intent="primary"
        minimal
        onClick={onAddTile}
      >
        Add Tile
      </Button>
      <Switch
        disabled={disabled}
        checked={snapEnabled}
        label="Snap to grid & edges"
        className="!mb-0"
        onChange={onToggleSnap}
      />
      <div className="flex items-center gap-2">
        <span className="text-sm text-slate-500">Grid</span>
        <NumericInput
          disabled={disabled || !snapEnabled}
          min={0}
          allowNumericCharactersOnly
          buttonPosition="none"
          className="w-16"
          value={gridSize}
          onValueChange={(value) => onGridSizeChange(value)}
        />
      </div>
    </div>
  );
}
